import * as React from 'react';
import * as styles from './StructureViewer.css';
import { IStructureElement, IStructureElementAction } from './IStructureElement';
import StructureViewerElement from './StructureViewerElement';

export interface IStructureViewerProps {
  structure: IStructureElement[];
  highlightColor: string;
  elementActions: IStructureElementAction[];
  style?: React.CSSProperties;
}

export interface IStructureViewerState {
}

export default class StructureViewer extends React.Component<IStructureViewerProps, IStructureViewerState> {

  constructor(props) {
    super(props);
  }

  public render(): JSX.Element {
    const style = this.props.style ?? {};
    return <div
      className={styles.IA_structureViewer}
      style={style}
    >
      {this.props.structure?.map((element, i) => {
        return <StructureViewerElement
          element={element}
          indentation={0}
          highlightColor={this.props.highlightColor}
          elementActions={this.props.elementActions}
          index={i}
          parentChildrenCount={this.props.structure.length}
          isTopLevel
        />
      })}
    </div>;
  }
}